import { render, staticRenderFns } from "./stateWatingModel8_nwd.vue?vue&type=template&id=b1bcc82a&scoped=true"
import script from "./stateWatingModel8_nwd.vue?vue&type=script&lang=js"
export * from "./stateWatingModel8_nwd.vue?vue&type=script&lang=js"
import style0 from "./stateWatingModel8_nwd.vue?vue&type=style&index=0&id=b1bcc82a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bcc82a",
  null
  
)

export default component.exports